// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Verification-heading-LgJgx {
	font-size: 36px;
	font-weight: 600;
	margin-bottom: 36px;
	margin-top: 0;
}

.Verification-activationStepPanel-eOL18 {
	max-width: 518px;
	margin: 0 auto;
	text-align: center;
	padding-top: 73px;
}

.Verification-textLead-PXcUz {
	font-size: 18px;
	text-align: center;
	margin-top: 24px;
	margin-bottom: 18px;
}

.Verification-btnPrimary-nTRqa,
.Verification-btnPrimary-nTRqa:focus,
.Verification-btnPrimary-nTRqa:hover,
.Verification-btnPrimary-nTRqa:active {
	background-color: transparent !important;
	color: var(--common-link-color) !important;
	border: none;
	border-bottom: 1px solid var(--common-link-color) !important;
	font-size: 18px;
	border-radius: 0;
	padding: 0;
	-webkit-box-shadow: unset;
	        box-shadow: unset;
}

.Verification-refreshImage-kYEQT {
	width: 100%;
	max-width: 30px;
	border: 1px solid var(--primary-border);
	border-radius: 50%;
	padding: 3px;
	cursor: pointer;
	margin: 0px 7px;
}

.Verification-flexButton-PvOO6 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Verification-specialPriceIcon-W8ehl {
	display: inline-block;
	position: relative;
}

.Verification-specialPriceIcon-W8ehl:hover .Verification-toolTip-lp9JT {
	display: block;
}

.Verification-toolTip-lp9JT {
	position: absolute;
	top: -104px;
	right: 0;
	left: -111px;
	display: none;
	background: var(--common-background-color);
	min-width: 300px;
	text-align: center;
	padding: 10px;
	border-radius: 4px;
	color: var(--white-text);
}

.Verification-toolTipRelativeSection-ZSeLO::after {
	content: '';
	height: 100%;
	width: 100%;
	position: absolute;
	left: -31px;
	right: 0;
	top: 88px;
	bottom: 0;
	text-align: center;
	background-color: var(--common-background-color);
	z-index: 1;
	max-width: 11px;
	max-height: 11px;
	-webkit-transform: rotate(136deg);
	-ms-transform: rotate(136deg);
	transform: rotate(136deg);
	margin: 0 auto;
}

.Verification-faqImage-JGQGr {
	width: 100%;
	max-width: 19px;
	vertical-align: middle;
	margin-right: 5px;
}

@media screen and (max-width: 767px) {
	.Verification-activationStepPanel-eOL18 {
		padding: 73px 10px 0;
	}

	.Verification-toolTip-lp9JT {
		left: -200px;
	}

	.Verification-toolTipRelativeSection-ZSeLO::after {
		left: 145px;
	}

}`, "",{"version":3,"sources":["webpack://./src/components/Booking/Verification/Verification.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAGA;;;;CAIC,wCAAwC;CACxC,0CAA0C;CAC1C,YAAY;CACZ,4DAA4D;CAC5D,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,yBAAiB;SAAjB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,uCAAuC;CACvC,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,YAAY;CACZ,aAAa;CACb,0CAA0C;CAC1C,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,gDAAgD;CAChD,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,iCAAiC;CACjC,6BAA6B;CAC7B,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC;EACC,oBAAoB;CACrB;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,WAAW;CACZ;;AAED","sourcesContent":[".heading {\n\tfont-size: 36px;\n\tfont-weight: 600;\n\tmargin-bottom: 36px;\n\tmargin-top: 0;\n}\n\n.activationStepPanel {\n\tmax-width: 518px;\n\tmargin: 0 auto;\n\ttext-align: center;\n\tpadding-top: 73px;\n}\n\n.textLead {\n\tfont-size: 18px;\n\ttext-align: center;\n\tmargin-top: 24px;\n\tmargin-bottom: 18px;\n}\n\n\n.btnPrimary,\n.btnPrimary:focus,\n.btnPrimary:hover,\n.btnPrimary:active {\n\tbackground-color: transparent !important;\n\tcolor: var(--common-link-color) !important;\n\tborder: none;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n\tfont-size: 18px;\n\tborder-radius: 0;\n\tpadding: 0;\n\tbox-shadow: unset;\n}\n\n.refreshImage {\n\twidth: 100%;\n\tmax-width: 30px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 50%;\n\tpadding: 3px;\n\tcursor: pointer;\n\tmargin: 0px 7px;\n}\n\n.flexButton {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.specialPriceIcon {\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.specialPriceIcon:hover .toolTip {\n\tdisplay: block;\n}\n\n.toolTip {\n\tposition: absolute;\n\ttop: -104px;\n\tright: 0;\n\tleft: -111px;\n\tdisplay: none;\n\tbackground: var(--common-background-color);\n\tmin-width: 300px;\n\ttext-align: center;\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tcolor: var(--white-text);\n}\n\n.toolTipRelativeSection::after {\n\tcontent: '';\n\theight: 100%;\n\twidth: 100%;\n\tposition: absolute;\n\tleft: -31px;\n\tright: 0;\n\ttop: 88px;\n\tbottom: 0;\n\ttext-align: center;\n\tbackground-color: var(--common-background-color);\n\tz-index: 1;\n\tmax-width: 11px;\n\tmax-height: 11px;\n\t-webkit-transform: rotate(136deg);\n\t-ms-transform: rotate(136deg);\n\ttransform: rotate(136deg);\n\tmargin: 0 auto;\n}\n\n.faqImage {\n\twidth: 100%;\n\tmax-width: 19px;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n}\n\n@media screen and (max-width: 767px) {\n\t.activationStepPanel {\n\t\tpadding: 73px 10px 0;\n\t}\n\n\t.toolTip {\n\t\tleft: -200px;\n\t}\n\n\t.toolTipRelativeSection::after {\n\t\tleft: 145px;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `Verification-heading-LgJgx`,
	"activationStepPanel": `Verification-activationStepPanel-eOL18`,
	"textLead": `Verification-textLead-PXcUz`,
	"btnPrimary": `Verification-btnPrimary-nTRqa`,
	"refreshImage": `Verification-refreshImage-kYEQT`,
	"flexButton": `Verification-flexButton-PvOO6`,
	"specialPriceIcon": `Verification-specialPriceIcon-W8ehl`,
	"toolTip": `Verification-toolTip-lp9JT`,
	"toolTipRelativeSection": `Verification-toolTipRelativeSection-ZSeLO`,
	"faqImage": `Verification-faqImage-JGQGr`
};
module.exports = ___CSS_LOADER_EXPORT___;
